export function ensureTrailingSlash(slug) {
  if (!slug) {
    return '/';
  }
  if (!slug.endsWith('/')) {
    return "".concat(slug, "/");
  }
  return slug;
}